import { UploadFileOutlined } from "@mui/icons-material";
import { Button, Typography, styled } from "@mui/material";
import { getCsvContent } from "../lib/format";
import { useConfig } from "../containers/ConfigContext";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function UploadCSVButton<T>(props: {
  onChange: (data: T[]) => void;
  keys: (keyof T)[];
  sample: string;
}) {
  const { onChange, keys, sample } = props;
  const { localized } = useConfig();

  const onUpload = async (e: any) => {
    try {
      const _members = await getCsvContent<T>(e.target.files[0], keys);
      if (_members.length > 0) {
        onChange(_members);
      }
    } catch (error: any) {
      window.webApp.showMessage(
        "error",
        `Error happened: ${error?.message || error}`,
      );
    }
    e.target.value = "";
  };

  const onDownloadSample = () => {
    const blob = new Blob([sample], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "sample.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  return (
    <>
      <Button
        variant="contained"
        component="label"
        className="initial-text width-100p"
        startIcon={<UploadFileOutlined />}
      >
        {localized("Import by csv")}
        <VisuallyHiddenInput
          type="file"
          accept=".csv, text/csv"
          onChange={onUpload}
        />
      </Button>
      <Typography
        color="primary"
        className="margin-t-normal pointer"
        onClick={onDownloadSample}
      >
        Download sample csv file
      </Typography>
    </>
  );
}
